const _temp0 = require("./gallery_2.webp");
const _temp1 = require("./gallery_3.webp");
const _temp2 = require("./main.webp");
module.exports = {
  "gallery_2": _temp0,
  "gallery_3": _temp1,
  "main": _temp2
}